import {
  IAction,
  ITableAction,
} from '@/pages/intelligence/pages/GlobalView/components/TopMarketGenreCore/types';
import { getSource } from '@/pages/intelligence/services/sourceMetrics';
import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { Justify, Layout, SearchBox, Table } from 'tea-component';
import SourceTable from '../Table';
import { useIntl, getLocale } from 'umi';

import { dbiPageLogMes } from "@/pages/intelligence/utils/buriedPointCfg"
import { buriedPointPage, buriedPointSearch } from "@/pages/home/utils/buriedPoint";
import { filterSourcesRecordsBySearch } from '../../../searchUtils';
const { Body, Content } = Layout;

export default function NewsCrawlers(props) {
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const debounce = useRef({ interval: 0, delay: 500 }).current;
  const [dataCN, setDataCN] = useState([]);
  const [dataEN, setDataEN] = useState([]);
  const [searchValue, setSearchValue] = useState('')
  const [searchShow, setSearchShow] = useState(false)
  const pageLogMes = dbiPageLogMes.sourcesMetricsSourcesNewsCrawlers;
  const [showCN, setShowCN] = useState([])
  const [showEN, setShowEN] = useState([])
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const [pageIndex, setPageIndex] = useState(1);

  const getData = () => {
    setLoading(true);
    getSource({ tab: 'news_crawlers' })
      .then((data) => {
        const res = data[0]?.list?.map((item, idx) => ({
          ...item,
          id: idx + 1,
        }));
        const res2 = data[1]?.list?.map((item, idx) => ({
          ...item,
          id: idx + 1,
        }));
        setDataCN(res);
        setDataEN(res2);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const data = useMemo(() => locale == 'zh-CN' ? dataCN : dataEN, [locale, dataCN, dataEN]);
  const show = useMemo(() => locale == 'zh-CN' && showCN.length > 0 ? showCN : showEN, [locale, showCN, showEN])
  const columns = [
    {
      key: 'id',
      fixed: 'left',
      align: 'left',
      width: 65,
      header: '#',
    },
    {
      key: 'data_source',
      fixed: 'left',
      align: 'left',
      // width: 200,
      header: formatMessage({ id: 'dbi-sm-filter-datasource' }),
    },
    {
      key: 'url',
      align: 'left',
      header: 'Url',
      render: (cvm) => cvm?.url ? cvm?.url : '-',
    },
  ];
  const debounceSearchChange = (word: string) => {
    clearTimeout(debounce.interval);
    // @ts-ignore
    debounce.interval = setTimeout(() => {
      handleSearch(word);
      if (pageLogMes?.pageId) {
        buriedPointSearch(
          { extInfo: pageLogMes?.pageId, typeId: pageLogMes?.typeId },
          word,
        );
      }
    }, debounce.delay);
  }
  const handleSearch = (word: string) => {
    if (word == '') {
      setSearchShow(false);
    } else {
      const showEN = filterSourcesRecordsBySearch(dataEN, word);
      const showCN = filterSourcesRecordsBySearch(dataCN, word);
      setShowCN(showCN);
      setShowEN(showEN);
      setSearchShow(true);
      setPageIndex(1);
    }
  }
  useEffect(() => {
    getData();
    buriedPointPage(pageLogMes);
  }, []);

  return (
    <div>
      <Table.ActionPanel>
        <Justify
          className="dbi-imurreports-justify"
          right={
            <SearchBox
              className="edit-search-box"
              placeholder={formatMessage({ id: 'dbi_search_for_source' })}
              value={searchValue}
              onSearch={() => {
                // debounceSearchChange() 
              }}
              onChange={(word) => {
                setSearchValue(word);
                if (word == '') {
                  setSearchShow(false);
                } else if (word.replace(/^\s*/g, '')) {
                  debounceSearchChange(word);
                }
              }}
              onClear={() => { setSearchShow(false) }}
            />
          }
        />
      </Table.ActionPanel>
      <SourceTable
        records={searchShow ? show : data}
        columns={columns}
        loading={loading}
        error={isError}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
      />
    </div>
  );
}
